import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import type { IDatepickerIImperativeHandleResult, IDateSelected } from '@/Module/Auth/Model/DataModel';
import { dayjs } from '@/Module/Core/Helper';
import DatepickerCarousel from './DatepickerCarousel';
const createYearArray = () => {
  const currentYear = dayjs().calendar('jalali').year();
  const durationYear = currentYear - 70;
  return Array.from({
    length: currentYear - durationYear + 1
  }, (_, index) => durationYear + index);
};
const createMonthArray = () => {
  return Array(12).fill(1).map((x, y) => x + y as number);
};
const createDayArray = ({
  year,
  month
}: IDateSelected) => {
  let dayCount = dayjs(`${year}-${month}-01`, {
    // @ts-ignore
    jalali: true
  }).calendar('jalali').startOf('month').daysInMonth();
  if (year === 1403) {
    dayCount += 1;
  }
  return Array(dayCount).fill(1).map((x, y) => x + y as number);
};
const YEARS = createYearArray();
const MONTHS = createMonthArray();
const Datepicker = forwardRef<IDatepickerIImperativeHandleResult>((_, ref) => {
  const today = useMemo(() => dayjs().calendar('jalali'), []);
  const [selectedDate, setSelectedDate] = useState<IDateSelected>({
    year: today.year() - 10,
    month: today.month() + 1,
    day: 1
  });
  const days = useMemo(() => createDayArray(selectedDate), [selectedDate.year, selectedDate.month]);
  useImperativeHandle(ref, (): IDatepickerIImperativeHandleResult => ({
    getDate: () => {
      return dayjs(`${selectedDate.year}-${selectedDate.month}-${selectedDate.day} 00:00:00`, {
        // @ts-ignore
        jalali: true
      }).startOf('day').toDate();
    },
    setDate: (date: Date | null) => {
      if (!date) return;
      const d = dayjs(date).calendar('jalali').startOf('day');
      setSelectedDate({
        year: d.year(),
        month: d.month() + 1,
        day: d.date()
      });
    }
  }), [selectedDate]);
  const onDateChange = (current: Partial<IDateSelected>) => {
    setSelectedDate(prevState => ({
      ...prevState,
      ...current
    }));
  };
  return <div className="flex w-full flex-row-reverse items-center justify-between gap-3 ">
      <DatepickerCarousel onChange={onDateChange} items={YEARS} type="year" current={selectedDate.year} title="سال" />
      <DatepickerCarousel onChange={onDateChange} items={MONTHS} type="month" current={selectedDate.month} title="ماه" />
      <DatepickerCarousel onChange={onDateChange} items={days} type="day" current={selectedDate.day} title="روز" />
    </div>;
});
Datepicker.displayName = 'Datepicker';
export default Datepicker;